/** @format */

import {
  hourMinuteSecond,
  hourMinute,
  monthDayHourMinute,
  maxMetric,
  sumMetric,
  avgMetric
} from 'src/config'
import { InstanceItem } from 'src/components/SelectInstance/constants'
import dayjs from 'dayjs'
import { _$ } from '@king-design/react'

export interface IChartDataProps {
  xData: string[]
  series: {
    name: string
    type: string
    smooth: true
    data: number[]
  }[]
  maxValue: number
  minValue: number
}

// 获取聚合函数
export const metricTotogetherMethod = (metric: string): string => {
  if (!metric) return ''
  if (maxMetric.includes(metric)) {
    return 'max'
  }
  if (sumMetric.includes(metric)) {
    return 'sum'
  }
  if (avgMetric.find(item => metric.indexOf(item) === 0)) {
    return 'avg'
  }
  return ''
}

// 根据日期差 计算X轴格式
export const calcDateFormat = (date, delay) => {
  const [start, end] = date
  if (start && end) {
    const diff = dayjs(end).diff(dayjs(start), 's')
    const oneDay = 24 * 60 * 60
    // 粒度 <= 60秒的 只展示时分秒
    if (parseInt(delay) < 60) {
      return hourMinuteSecond
    } else {
      if (diff <= oneDay) {
        // 0-24小时
        return hourMinute
      } else {
        return monthDayHourMinute
      }
    }
  }
  return monthDayHourMinute
}

// 计算可选粒度
export const calcSelectInterval = (date, delay) => {
  const [start, end] = date
  delay = parseInt(delay) ? delay : '60'
  if (start && end) {
    const diff = dayjs(end).diff(dayjs(start), 's')
    const oneDay = 24 * 60 * 60
    if (diff <= oneDay) {
      // 0-24小时
      return _derepeatedSort(
        [delay, '60', '300', '600', '1800', '3600'].filter(num => parseInt(num) >= delay),
        diff
      ).map(item => item + '')
    } else if (diff <= 7 * oneDay) {
      // 1-7天
      return ['300', '600', '1800', '3600']
    } else if (diff <= 15 * oneDay) {
      // 8-15天
      return ['600', '1800', '3600']
    } else if (diff <= 30 * oneDay) {
      // 16-30天
      return ['1800', '3600']
    }
  }
  return [delay]
}

// 数组去重排序
export const _derepeatedSort = (arr: string[], diff): number[] => {
  return Array.from(new Set(arr.map(item => parseInt(item))))
    .sort((a, b) => a - b)
    .filter(item => item <= diff)
}

// 请求图表Lines
export const getQueryDataLines = (lines, productType) => {
  return lines.map(({ instance, legend, lineId, metricKey, tags }) => ({
    instance,
    legend,
    lineid: lineId,
    metric: metricKey,
    producttype: parseInt(productType),
    tags: { ...tags }
  }))
}

// 请求图表Params
export const getQueryDataParams = (
  chartData,
  instanceId,
  rangeDate,
  productType,
  delayValue = ''
) => {
  const { lines } = chartData
  const [start, end] = rangeDate
  const delay = lines[0]?.delay
  const period = delayValue || calcSelectInterval(rangeDate, delay)[0]
  const params: any = {
    StartTime: dayjs(start).set('second', 0).unix(),
    EndTime: dayjs(end).set('second', 0).unix(),
    Period: parseInt(period),
    Metrics: lines.map(line => {
      const { metricKey, legend, tags } = line
      return {
        ProductType: productType,
        InstanceID: instanceId,
        MetricName: metricKey,
        Tags: tags ? { ...tags } : undefined,
        MetricDesc: legend
      }
    })
  }
  return params
}

// 监控项 applications
export interface MointorItemProps {
  appId: number
  name: string
  graphs: MointorGraphsProps[]
}

// 监控项 graphs
export interface MointorGraphsProps {
  graphId: number
  title: string
  graphType: string
  units: string
  lines: any[]
}

// 自定义聚合实例Form
export interface CustomInstanceFormValue {
  instanceId?: string
  instanceName: string
  associatedResources: InstanceItem[]
  metric: {
    aggregateType?: string
    delay?: ''
    metricKey?: string
    metricName?: string
  }
  aggregateTags?: {
    province: string[]
    isp: string[]
  }
  region?: string
}

// 自定义聚合实例Form初始值
export const customInstanceInitFormValue: CustomInstanceFormValue = {
  instanceName: '',
  associatedResources: [],
  metric: {
    aggregateType: 'sum',
    metricKey: '',
    metricName: '',
    delay: ''
  },
  aggregateTags: {
    province: [],
    isp: []
  },
  region: localStorage.getItem('systemId')
}

// 自定义聚合实例FormProps
export interface CustomInstanceDialogProps {
  visible: boolean
  handleChange: (c: any, show: boolean) => void
  defaultFormValue?: CustomInstanceFormValue
  updateTable?: () => void
}

// 监控项、省份、运营商的Item
export interface MetricsItem {
  metricKey: string
  metricName: string
  delay: number
  tags?: string
}

export interface TagItem {
  key: string
  name: string
}

export const handleMetricsList = (object): TagItem[] => {
  return Object.entries(object).map(([key, name]) => ({
    key,
    name
  })) as TagItem[]
}

// 聚合维度
export type AggregatorKeys = 'max' | 'min' | 'avg'
export const AggregatorEnum = [
  { label: _$('最大值'), value: 'max' },
  { label: _$('最小值'), value: 'min' },
  { label: _$('平均值'), value: 'avg' }
]
